import { ReactNode, useEffect } from 'react';

interface Props {
  title: string;
  body: ReactNode;
  detail?: ReactNode;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  busy?: boolean;
  tone?: 'danger' | 'primary';
}

export function ConfirmModal({
  title,
  body,
  detail,
  confirmLabel,
  onCancel,
  onConfirm,
  busy = false,
  tone = 'danger',
}: Props) {
  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) onCancel(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [busy, onCancel]);

  return (
    <div className="ts-overlay" onClick={busy ? undefined : onCancel} role="presentation">
      <div
        className="ts-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ts-modal-body">
          <h3 className="ts-modal-title">{title}</h3>
          <div className="ts-modal-text">{body}</div>
          {detail && <div className="ts-modal-detail">{detail}</div>}
        </div>
        <div className="ts-modal-foot">
          <span className="ts-modal-hint">Esc to cancel</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="ts-btn ts-btn--secondary" onClick={onCancel} disabled={busy}>
              Cancel
            </button>
            <button
              type="button"
              className={'ts-btn ' + (tone === 'danger' ? 'ts-btn--danger' : 'ts-btn--primary')}
              onClick={onConfirm}
              disabled={busy}
            >
              {busy ? 'Working…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
